import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchInput from '../../../components/SearchInput/SearchInput';
import { BannerStatus } from '../../../models/BannersModels';
import StatusFilterChip from './BannersTableFiltersStyle';

export const StatusFilterOptions: Array<BannerStatus | 'ALL'> = [
  'ALL',
  BannerStatus.ACTIVE,
  BannerStatus.SCHEDULED,
  BannerStatus.DRAFT,
  BannerStatus.EXPIRED,
  BannerStatus.CANCELED,
];

interface BannersTableFiltersProps {
  onSearch: (query: string) => void;
  isLoading: boolean;
  statusFilter: BannerStatus | 'ALL';
  onStatusFilterChange: (status: BannerStatus | 'ALL') => void;
}

function BannersTableFilters({
  onSearch,
  isLoading = false,
  statusFilter,
  onStatusFilterChange,
}: BannersTableFiltersProps) {
  const [t] = useTranslation();

  return (
    <Grid container columnSpacing="1.5rem" sx={{ paddingTop: '1.5rem', paddingBottom: '1rem' }}>
      <Grid item xl={5} md={6} xs={12} sx={{ paddingBottom: { md: '0', xs: '1rem' } }}>
        <SearchInput
          label={t('pages.banners.table.filters.search')}
          onSearch={onSearch}
          placeholder={t('pages.banners.table.filters.searchPlaceholder')}
          isButtonDisabled={isLoading}
        />
      </Grid>
      <Grid item xl={7} md={6} xs={12}>
        <Box sx={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'end', height: '100%' }}>
          {StatusFilterOptions.map((status) => (
            <StatusFilterChip
              key={status}
              label={
                status === 'ALL'
                  ? t('pages.banners.table.filters.statusAll')
                  : t(`pages.banners.table.status.${status}`)
              }
              selected={statusFilter === status}
              onClick={() => onStatusFilterChange(status)}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
}

export default BannersTableFilters;
